/**
 * Whether a search param carries a pagination cursor (`nextCursor`, `prevCursor`, or a
 * namespaced variant). Tables, filters, and tab switches use this to decide which params
 * belong to the current page of results rather than to the view.
 */
export function isPaginationCursorParam(param: string): boolean {
  return param.toLowerCase().includes('cursor');
}
